import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';

import { InboxService } from './inbox.service';

export function provideInbox(): (Provider | EnvironmentProviders)[] {
  return [provideEnvironmentInitializer(() => inject(InboxService))];
}
